import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import clients from './modules/clients'
import admin from './modules/admin'
import manager from './modules/manager'
import simulations from './modules/simulations'
import storage from './modules/storage'
import metrics from './modules/metrics'
import settings from './modules/settings'
import playground from './modules/playground'
import ai from './modules/ai'
import shared from './modules/shared'
import autoModels from './modules/autoModels'
import createErrorLoggingPlugin from './plugins/errorLoggingPlugin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    clients,
    admin,
    manager,
    simulations,
    storage,
    metrics,
    settings,
    playground,
    ai,
    shared,
    autoModels
  },
  plugins: [
    createErrorLoggingPlugin()
  ]
})
